import { Setting } from "../App";
import { useState } from "react";
import axios from "axios";
import { CUSTOMER_API_URL } from "../constants";
import {
  AddSubscriptionLineApiType,
  AddSubscriptionLineResponseType,
  AddSubscriptionLineResponseTypeDefine,
} from "../types/api/add-subscription-line-api-type";

export const useSubscriptionAdd = (setting: Setting) => {
  const [parameters, setParameters] = useState<{
    variantId: string;
    quantity: number;
    sellingPlanId: string;
    price: string;
    planPrice: string;
    btnTitle: string;
    btnClassName: string;
  }>();

  const subscriptionAdd =
    async (): Promise<AddSubscriptionLineResponseType> => {
      if (!parameters)
        return AddSubscriptionLineResponseTypeDefine.PARAMETERS_UNDEFINED;

      const planId = `gid://shopify/SellingPlan/${parameters.sellingPlanId}`;
      const variantId = `gid://shopify/ProductVariant/${parameters.variantId}`;
      const quantity = Number(parameters.quantity);

      try {
        const addSubscriptionResponse = await axios.post(
          `${CUSTOMER_API_URL}?action=addSubscriptionLineToFirstSubscription`,
          {
            planId,
            variantId,
            quantity,
          },
          { headers: { Authorization: setting.token } }
        );

        const status = (
          addSubscriptionResponse.data as AddSubscriptionLineApiType
        ).status;

        switch (status) {
          case AddSubscriptionLineResponseTypeDefine.NONE_SUBSCRIPTION:
            return AddSubscriptionLineResponseTypeDefine.NONE_SUBSCRIPTION;
          case AddSubscriptionLineResponseTypeDefine.SAME_PRODUCT:
            return AddSubscriptionLineResponseTypeDefine.SAME_PRODUCT;
        }
      } catch (e) {
        return AddSubscriptionLineResponseTypeDefine.API_ERROR;
      }

      return AddSubscriptionLineResponseTypeDefine.SUCCESS;
    };

  return {
    parameters,
    setParameters,
    subscriptionAdd,
  };
};
